export var secondReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/;
export var dateReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;